import { useState } from "react";
import { MessageSquare } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import FeedbackModal from "@/components/FeedbackModal";

/**
 * Floating feedback button. Rendered globally inside AuthProvider, visible
 * only when a user is signed in. Positioned bottom-right, above iOS/Android
 * safe-area inset, never overlaps the existing footer feedback link on
 * Dashboard (the link still works as a secondary entry point).
 */
export default function FeedbackFab() {
    const { user } = useAuth();
    const [open, setOpen] = useState(false);

    if (!user) return null;

    return (
        <>
            <button
                data-testid="feedback-fab"
                type="button"
                aria-label="Send feedback"
                onClick={() => setOpen(true)}
                style={{
                    position: "fixed",
                    right: "calc(env(safe-area-inset-right, 0px) + 18px)",
                    bottom: "calc(env(safe-area-inset-bottom, 0px) + 18px)",
                    zIndex: 90,
                    width: 48,
                    height: 48,
                    borderRadius: "50%",
                    border: "1px solid var(--bm-gold-dim)",
                    background: "linear-gradient(180deg, #1a2942 0%, #0f1d33 100%)",
                    color: "var(--bm-gold)",
                    boxShadow: "0 8px 22px -6px rgba(0,0,0,0.55), 0 2px 6px rgba(0,0,0,0.35)",
                    cursor: "pointer",
                    display: "grid",
                    placeItems: "center",
                    transition: "transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease",
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow = "0 12px 28px -6px rgba(0,0,0,0.6), 0 4px 10px rgba(0,0,0,0.4)";
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 8px 22px -6px rgba(0,0,0,0.55), 0 2px 6px rgba(0,0,0,0.35)";
                }}
                title="Send feedback"
            >
                <MessageSquare size={20} />
            </button>
            <FeedbackModal open={open} onClose={() => setOpen(false)} />
        </>
    );
}
